<template>
	<page>
		<module>
			<view-list
				ref="view"
				work-type="41"
				selector
			>
				<template #search>
					<m-search ref="search">
						<m-search-item label="场次">
							<c-input name="auction_batch_no"></c-input>
						</m-search-item>
						<m-search-item label="报告时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<!--导出不做按钮级权限控制：能看到本菜单即可导出-->
				<template #operate>
					<c-button prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
				</template>

				<!--选中态 operate 槽被批量条替换，导出入口须在此复放（同客户/供应商列表先例）；勾选后仅导出选中行-->
				<template #batchOperate="{data}">
					<c-button prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
				</template>

				<!-- 金额列红色展示 -->
				<template #deal_amount="{data}">
					<span style="color: #e53e3e;">{{formatPrice(data.deal_amount)}}</span>
				</template>
				<template #gross_profit="{data}">
					<span style="color: #e53e3e;">{{formatPrice(data.gross_profit)}}</span>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="220"
					button-limit="6"
				>
					<template #default="{data}">
						<c-table-button icon="tf-detail" @click="viewDetail(data)">报告详情</c-table-button>
						<c-table-button icon="tf-detail" @click="viewDealDetail(data)">成交明细</c-table-button>
						<c-table-button icon="tf-export" @click="exportDealDetail(data)">导出明细</c-table-button>
					</template>
				</c-table-column>
			</view-list>

			<!-- 统计报告详情 -->
			<auction-stat-report-detail ref="detail"></auction-stat-report-detail>
			<!-- 成交明细 -->
			<auction-deal-detail ref="dealDetail"></auction-deal-detail>
		</module>
	</page>
</template>

<script>
	import AuctionStatReportDetail from './auction_stat_report_detail';
	import AuctionDealDetail from './auction_deal_detail';

	export default {
		components: {
			AuctionStatReportDetail,
			AuctionDealDetail
		},

		methods: {
			/*********查看统计报告详情**********/
			viewDetail(data) {
				this.$refs.detail.open({
					id: data.id
				});
			},

			/*********查看成交明细**********/
			viewDealDetail(data) {
				this.$refs.dealDetail.open({
					auction_batch_no: data.auction_batch_no
				});
			},

			/*********按场次导出成交明细（与成交明细弹窗同源）**********/
			exportDealDetail(data) {
				this.request({
					url: '/sale/auction/report/stat/deal/export/url',
					data: {
						auction_batch_no: data.auction_batch_no
					},
					loading: true,
					success: res => {
						if (res && res.url) {
							this.download({
								fileName: res.filename,
								url: res.url,
								loading: {
									message: '正在导出成交明细...'
								}
							});
						}
					}
				});
			},

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			}
		}
	}
</script>
